function blockCountry() {
    var xhr = new XMLHttpRequest();
    xhr.open('GET', 'https://ipapi.co/json/', true);
    xhr.onload = function () {
      var data = JSON.parse(this.responseText);
      var countryCode = data.country;
      var blockedCountries = ['CN', 'RU']; //country codes to block src https://en.wikipedia.org/wiki/ISO_3166-1_alpha-2
      if (blockedCountries.indexOf(countryCode) !== -1) {
        window.location.href = 'https://google.com/'; // Replace "url" with the URL of the page you want to redirect to
      }
    };
    xhr.send();
}

blockCountry();